<template>
  <div class="ui centered padded grid">
    <div class="eight wide computer sixteen wide mobile column">
      <div class="ui inverted segment">

        <center>
          <img class="ui image" src="../../static/assets/unicorn.png">
        </center>
        <div class="ui header">{{ localization.genericMessages.genericErrorHeader }}</div>
        <div v-html="localization.genericMessages.genericErrorBody"/>
      </div>

      <div class="ui tertiary bottom fixed tiny inverted menu">
        <p class="item">{{ localization.genericMessages.doNotRefresh }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ErrorMessage.vue